module.exports = __webpack_public_path__ + "static/media/coupon02_ja.b2ff1fb6.png";